import { getClosestTailwindColor } from "../index.js";

export const getTailwindClassNamesFromHex = (
  hex?: string | null,
  gradients = true
) => {
  const color = hex
    ? (getClosestTailwindColor(hex)?.name ?? "mono-200")
    : "mono-200";

  const baseColor = color.split("-")[0];
  const shade = Number(color.split("-")[1]);
  // rounder number to nearest 100
  const darkShade =
    Number(shade) < 500
      ? Math.min(
          Math.max(
            Math.round(Math.max(Number(shade) - 500, 200) / 100) * 100,
            600
          ),
          900
        )
      : Math.min(Math.max(Math.round(Number(shade) / 100) * 100, 600), 900);
  const lightShade =
    Number(shade) >= 500
      ? Math.min(
          Math.max(
            Math.round(Math.max(Number(shade) - 500, 200) / 100) * 100,
            200
          ),
          300
        )
      : Math.min(Math.max(Math.round(Number(shade) / 100) * 100, 200), 300);
  return ` text-${baseColor}-800 dark:text-${baseColor}-100 bg-${baseColor}-${lightShade} dark:bg-${baseColor}-${darkShade} 
  
  ${
    gradients &&
    `bg-linear-to-br from-${baseColor}-${lightShade} to-${baseColor}-${
      lightShade + 100
    } dark:from-${baseColor}-${darkShade} dark:to-${baseColor}-${Math.min(
      darkShade + 100,
      950
    )}`
  }`;
};
